import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ReportTreeNode } from '../../../../../shared/models/responses';
import { ReportSources } from '../../../../../core/components/reports/models/enums';

@Component({
  selector: 'app-report-type-editor-item',
  templateUrl: './report-type-editor-item.component.html',
  styleUrls: ['./report-type-editor-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportTypeEditorItemComponent implements OnInit, OnChanges {
  @Input() node: ReportTreeNode;
  @Input() nestingLevel = 0;
  @Input() selectedNode: ReportTreeNode | null = null;
  @Input() expandFavorites = false;
  @Input() hideArchivedCategories = true;
  @Output() nodeClick = new EventEmitter<ReportTreeNode>();
  @Output() openNewCategoryModal = new EventEmitter<ReportTreeNode>();
  @Output() openEditCategoryModal = new EventEmitter<ReportTreeNode>();
  @Output() toggleCategoryActive = new EventEmitter<ReportTreeNode>();
  @Output() duplicateReportType = new EventEmitter<ReportTreeNode>();


  public reportSources = ReportSources;
  
  isExpanded = false;
  showSourceInfo = false;

  constructor() { }

  ngOnInit() {
    // Start all nodes closed by default
    this.isExpanded = false;

    if (this.expandFavorites && this.nodeContainsFavorite(this.node)) {
      this.isExpanded = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['expandFavorites'] && this.expandFavorites) {
      // When expandFavorites is turned on, expand nodes that contain a favorite
      this.isExpanded = this.nodeContainsFavorite(this.node);
    }
  }

  onNodeClick() {
    if (this.node.children && this.node.children.length > 0) {
      // If it has children, toggle expansion
      this.isExpanded = !this.isExpanded;
    }
    
    // Always emit the node click for parent to handle
    this.nodeClick.emit(this.node);
  }

  onChildNodeClick(childNode: ReportTreeNode) {
    this.nodeClick.emit(childNode);
  }

  hasChildren(): boolean {
    return !!this.node && !!this.node.children && this.node.children.length > 0;
  }

  hasSourceName(): boolean {
    return !!this.node.sourceName;
  }

  isSelected(): boolean {
    return this.selectedNode !== null && this.selectedNode.id === this.node.id;
  }

  private nodeContainsFavorite(node: ReportTreeNode | null | undefined): boolean {
    if (!node) {
      return false;
    }

    if (node.isFavorite) {
      return true;
    }

    if (node.children && node.children.length > 0) {
      return node.children.some(child => this.nodeContainsFavorite(child));
    }

    return false;
  }

  public onAddCategoryClick(){
    this.openNewCategoryModal.emit(this.node);
  }
  
  public onEditCategoryClick(){
    this.openEditCategoryModal.emit(this.node);
  }
  public onChildAddCategoryClick(childNode: ReportTreeNode){
    this.openNewCategoryModal.emit(childNode);
  }

  public onChildEditCategoryClick(childNode: ReportTreeNode){
    this.openEditCategoryModal.emit(childNode);
  }

  public onToggleCategoryActiveClick() {
    this.toggleCategoryActive.emit(this.node);
  }

  public duplicateNode() {
    if (this.node && this.node.sourceId) {
      this.duplicateReportType.emit(this.node);
    }
  }
  public onChildDuplicateReportType(childNode: ReportTreeNode) {
    this.duplicateReportType.emit(childNode);
  }

}



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/report-type-editor/report-type-editor-item/report-type-editor-item.component.ts